import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import applicationReducer from './applicationReducer';
import authReducer from './auth/authReducer';
import recoverReducer from './auth/recoverReducer';
import registrationReducer from './registration/registrationReducer';
import couponReducer from './coupon/couponReducer';
import rechargeReducer from './recharge';
import withdrawReducer from './withdraw';
import balanceReducer from './balanceReducer';
import promoReducer from './promoReducer';
import newsReducer from './news/newsReducer';
import gamesReducer from './games';
import betradarReducer from './betradarReducer';
import promocodeReducer from './promo-code/promocodeReducer';
import { reducer as formReducer } from 'redux-form';
export default combineReducers({
    routing: routerReducer,
    application: applicationReducer,
    auth: authReducer,
    recover: recoverReducer,
    registration: registrationReducer,
    coupon: couponReducer,
    balance: balanceReducer,
    recharge: rechargeReducer,
    withdraw: withdrawReducer,
    promo: promoReducer,
    promoCode: promocodeReducer,
    news: newsReducer,
    form: formReducer,
    games: gamesReducer,
    betradar: betradarReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js